import {
  BookingTypeEnum,
  InvestmentQuoteNotationEnum,
  InvestmentTypeEnum,
  QuoteV2PriceUnitEnum,
} from "@bn/api/apiv1";
import { toCurrency, toPercent, toGermanNumberFormat } from "./numberFormat";

export type PercentageRange = "0-1" | "0-100";

export interface GetValueByInvestmentAndBookingType {
  value: number;
  investmentType: InvestmentTypeEnum;
  bookingType?: BookingTypeEnum;
  currency?: string;
  percentageRange?: PercentageRange;
  quoteNotation?: InvestmentQuoteNotationEnum | QuoteV2PriceUnitEnum;
}

const isPercentNotation = (
  investmentType: InvestmentTypeEnum,
  quoteNotation?: InvestmentQuoteNotationEnum | QuoteV2PriceUnitEnum
) => {
  if (quoteNotation) return quoteNotation === "PERCENT";
  return investmentType === "31_bond";
};

export const getValueByInvestmentAndBookingType = ({
  value,
  investmentType,
  bookingType,
  currency = "EUR",
  percentageRange = "0-1",
  quoteNotation,
}: GetValueByInvestmentAndBookingType): string => {
  if (bookingType === "split" || bookingType === "reverse_split") {
    return "";
  }

  if (isPercentNotation(investmentType, quoteNotation)) {
    if (bookingType === "dividend" || bookingType === "purchase_right") {
      return toCurrency(value, currency);
    }

    if (percentageRange === "0-100") {
      const formattedValue = toGermanNumberFormat(value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return `${formattedValue} %`;
    }

    return toPercent(value);
  }

  return toCurrency(value, currency);
};
